import Vue from 'vue'

import App from './App.vue'
import router from './router/index.js'

//注册全局的组件
import axios from 'axios'
Vue.prototype.$http=axios;

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

//新的vue
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
